<template>
  <view class="notify">
    <view class="header">
      <tab-list
        :list="tabList"
        :line-width="70"
      />
      <span>清除未读</span>
    </view>
    <view class="list">	
      <uni-swipe-action>
        <uni-swipe-action-item
          :right-options="options"
          @click="bindClick"
        >
          <view class="cont">
            <div class="title">
              <div class="point" />
              <span>活动开始通知</span>
            </div>
            <p class="font-11 color-666">
              你好，恭喜您注册成功！系统会为你进行优先推荐，清您及时查收消息，及时反馈...
            </p>
            <p class="footer">
              <span class="color-999 font-11">2019-01-01 16:11:11</span>
              <span class="show">展开</span>
            </p>
          </view>
        </uni-swipe-action-item>
      </uni-swipe-action>
    </view>
  </view>
</template>

<script>
import uniSwipeAction from '@/components/uni-swipe-action/uni-swipe-action.vue';
import uniSwipeActionItem from '@/components/uni-swipe-action-item/uni-swipe-action-item.vue';
import tabList from '@/components/tab-bar/index.vue';
export default {
	components: {uniSwipeAction,uniSwipeActionItem,tabList},
	data(){
		return{
			list : [
					{
						id: 1,
						image: '../../static/slide-list/logo.png',
						title: '张三',
						rightDetail: '2019-03-18',
						detail: 'XXXXXXXXXXXXXXXXXXX公司',
						slide_x: 0
					},
					{
						id: 2,
						surname: '李',
						title: '李二',
						rightDetail: '2019-03-17',
						detail: 'XXXXXXXXXXXXXXXXXXX公司',
						slide_x: 0
					},
				],
				tabList:[
					{
						title:'最新消息'
					},
					{
						title:'历史消息'
					}
				],
				page: {
				    pageSize: 10,
				    currentPage: 1,
				    count: 0,
					end:false,
				    loading: false
				},
				options:[
					{
						text: '已读',
						style: {
							backgroundColor: '#D8D8D8'
						}
					}, {
						text: '删除',
						style: {
							backgroundColor: '#F16346'
						}
					}
				]
		};
	},
	onPullDownRefresh() {
	    this.list=[];
	    this.page.currentPage=1;
		uni.stopPullDownRefresh();
	    // this.getList('refresh')
	},
	onReachBottom() {
	    if(this.list.length<this.page.count){
	        // this.getList()
	    }
	},
	methods:{
		 bindClick(e){
		console.log('点击了'+(e.position === 'left' ? '左侧' : '右侧') + e.content.text + '按钮');
		},
		tabClick(index){
			this.hover=index;
		},
		//列表页
		getList(status){
		    this.page.loading=true;
		    let inDate = _this.dateFormat(_this.info.checkInDate);
		    let outDate = _this.dateFormat(_this.info.checkOutDate);
		    this.$ajax({
		        method: 'post',
		        url: '/weChat/hotelbody/queryPage',
		        data: {
		        },
		    }).then(res=>{
		        this.list.push.apply(_this.list,res.data);
		        this.page.loading=false;
		        this.page.count=res.count;
		        if(_this.list.length>=this.page.count){
		            this.page.end=true;
		        }
		        this.page.currentPage+=1;
		        if(status==='refresh'){
		            uni.stopPullDownRefresh();
		        }
		        // console.log(_this.list[1].referPrice>0)
		    });
		    
		}
	}
};
</script>

<style lang="less" scoped>
.notify{
	.header{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding:0 30upx 0 30upx;
		margin-top:36upx;
		position: relative;
		
	}
	.list{
		margin-top:40upx;
		.cont{
			border-bottom:1px #ECECEC solid;
			padding:16upx 30upx;
			width:100%;
			box-sizing: border-box;
			line-height: 36upx;
			.title{
				font-weight: bold;
				margin:10upx 0;
				display: flex;
				align-items: center;
			}
			.point{
				width:14upx;
				height:14upx;
				border-radius: 14upx;
				background:#F16346;
				margin:0 10upx 0 0;
			}
			.footer{
				display: flex;
				justify-content: space-between;
				margin-top:10upx;
				.show{
					color:#C3986D;
				}
			}
		}
	}
}
</style>
